module.exports = __webpack_public_path__ + "static/media/emoji-low-score-2x.7ec891af.png";